/* Utils */
import { useState } from 'react';
import uid from 'uuid/v4';


/* Components */
import Icon from 'Components/Icon';

/* Styles */
import './style.scss';

const ContextualMenu = ({
	icon, label, position, button, handleAction, items, smallItems, isTop
}) => {
	const [visible, setVisible] = useState(false);
	const handleVisible = e => {
		e.stopPropagation();
		setVisible(!visible);
	};
	const handleNotVisible = e => {
		e.stopPropagation();
		setVisible(false);
	};

	return (
		<>
			{ icon && !button && <Icon name={icon} isHM label={label} position={position} onClick={handleVisible} /> }
			{ button && (
				<span className="btn btn-default" onClick={handleVisible} role="button" tabIndex={0}>
					{ icon && <Icon name={icon} isHM label={label} position={position} /> } {button}
				</span>
			)}
			<div className="contextual-menu-component-wrapper">
				<div className={`contextual-menu-component ${visible ? 'visible' : ''} ${isTop ? 'top' : 'bottom'}`}>
					{items.map((item) => (
						<div
							key={uid()}
							className={`item ${item.danger ? 'danger' : ''} ${smallItems ? 'small' : ''}`}
							onClick={(e) => {
								handleAction(item.value);
								handleNotVisible(e);
							}}
							tabIndex={0}
							role="button"
						>
							{item.label}
						</div>
					))}
				</div>
				<div className={`contextual-menu-close ${visible ? 'enabled' : ''}`} onClick={handleNotVisible} role="button" tabIndex={0} />
			</div>
		</>
	);
};

ContextualMenu.propTypes = {
	handleAction: PropTypes.func.isRequired,
	icon: PropTypes.string,
	label: PropTypes.string,
	position: PropTypes.string,
	button: PropTypes.string,
	smallItems: PropTypes.bool,
	items: PropTypes.arrayOf(PropTypes.shape({
		label: PropTypes.string,
		action: PropTypes.func,
		danger: PropTypes.bool
	})).isRequired,
	isTop: PropTypes.bool
};

ContextualMenu.defaultProps = {
	smallItems: false,
	icon: null,
	label: null,
	position: null,
	button: null,
	isTop: false
};

export default ContextualMenu;
